<template>
  <div class="modal-out">
    <div class="modal" style="width: 500px">
      <div class="modal-header">
        <div class="title">添加SOS联系人</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body" style="min-height: auto">
        <template>
          <el-row style="margin-bottom: 25px;" >
            <el-col :span="12" class="item" >
              <span>姓名:</span>
              <el-input placeholder="请输入姓名" v-model="contacts.name" maxlength="11" clearable
                        style="width:100%;margin-top:5px"></el-input>
            </el-col>

            <el-col :span="12" class="item">
              <span>手机号:</span>
              <el-input placeholder="请输入手机"  v-model="contacts.phone" maxlength="11" clearable
                        style="width:100%;margin-top:5px"></el-input>
            </el-col>
          </el-row>


        </template>
      </div>
      <div class="modal-footer">
            <el-button :loading="loading" type="primary" @click="AddSOSContacts">添加</el-button>
          </div>
    </div>


  </div>
</template>

<script>




export default {
  name: "AddContacts",
  data() {
    return {
      addContactsShow:false,
      userCode: '',
      tableData:'',
      contacts:{
        name:'',
        phone:'',
      }

    }
  },
  components: {

  },

  methods: {
    init(row, userCode) {
      this.userCode = userCode;
      this.contacts.name='';
      this.contacts.phone='';
    },
    closeSelf() {
      this.$emit("closeAddContacts");
    },
    closeAddContacts(){
      this.addContactsShow =!this.addContactsShow;
    },
    AddSOSContacts(){
      if(this.name===''){
        this.$message({type: 'warning', message: '请填写姓名!'});
      }else if(this.phone===''){
        this.$message({type: 'warning', message: '请填写手机号码!'});
      }
      var a =JSON.parse(JSON.stringify(this.contacts))
      this.$emit("getData",a);
      this.$emit("closeAddContacts");
    },



  }


}
</script>

<style lang="scss" scoped>

</style>